import React, { useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
} from "@mui/material";
import { Link } from "react-router-dom";

/* ─────────────────────────────────────────
   Mini‑card for the four menu items
   ───────────────────────────────────────── */
const ItemCard = ({ img, title }) => (
  <Card
    sx={{
      maxWidth: 380,
      width: "100%",
      background: "transparent",
      color: "#fff",
      borderRadius: "30px",
      m: "5px 2px !important",
      overflow: "hidden",
    }}
  >
    <CardActionArea>
      <CardMedia
        component="img"
        image={img}
        alt={title}
        sx={{ aspectRatio: "1 / 1", objectFit: "cover" }}
      />
      <CardContent
        sx={{
          py: "4px",
          textAlign: "center",
          background: "#00AAE3",
          minHeight: 25,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontSize: "16px", fontWeight: 700, m: 0, lineHeight: 1.3 }}
        >
          {title}
        </Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

/* ─────────────────────────────────────────
   Main Product‑Hero component
   ───────────────────────────────────────── */
export default function FourProductCardBox(props) {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#0f0f0f !important",
        color: "#fff",
        fontFamily: '"Open Sans", Arial, sans-serif',
      }}
    >
      {/* HERO SECTION */}
      <Box sx={{ flex: 1, px: { xs: 2, md: 0 }, pt: "50px" }}>
        <Box sx={{ maxWidth: 1240, width: "82%", mx: "auto" }}>
          <Grid container spacing={4}>
            {/* Hero Image */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                }}
              >
                <Box
                  component="img"
                  src={props.cardImg}
                  alt="Product hero"
                  sx={{ width: { xs: "95%", md: "100%" }, mt: { xs: 2, md: 6 } }}
                />
              </Box>
            </Grid>

            {/* Hero Text */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2 }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: "bold",
                    mb: 2,
                    fontSize: { xs: "24px", sm: "30px", md: "35px" },
                    textTransform: "uppercase",
                  }}
                >
                  {props.titleHead}
                </Typography>

                {props.titleSubHead && (
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      fontSize: { xs: "12px", sm: "13px", md: "14px" },
                    }}
                  >
                    {props.titleSubHead}
                  </Typography>
                )}

                {props.detailHead && (
                  <Typography
                    component="p"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      mt: 3,
                      fontSize: { xs: "15px", md: "16px" },
                    }}
                  >
                    {props.detailHead}
                  </Typography>
                )}

                <Box sx={{ borderBottom: "1px solid #fff", mt: 4 }} />

                {props.detailBody && (
                  <Typography
                    variant="body1"
                    sx={{ mb: 2, lineHeight: 1.6, mt: 4, fontSize: { xs: "15px", md: "16px" } }}
                  >
                    {props.detailBody}
                  </Typography>
                )}

                {props.detailBodyBr && (
                  <Typography
                    variant="body1"
                    sx={{ mb: 0, lineHeight: 1.6, fontSize: { xs: "15px", md: "16px" } }}
                  >
                    {props.detailBodyBr}
                  </Typography>
                )}

                {props.detailBody2 && (
                  <Typography
                    component="p"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      lineHeight: 1.6,
                      mt: 2,
                      fontSize: { xs: "15px", md: "16px" },
                    }}
                  >
                    {props.detailBody2}
                  </Typography>
                )}

                {props.detailBody3 && (
                  <Typography
                    component="p"
                    sx={{ mb: 2, mt: 2, fontSize: { xs: "15px", md: "16px" } }}
                  >
                    {props.detailBody3}
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* GLOBAL DIVIDER – spans both columns */}
          <Box sx={{ borderBottom: "1px solid #fff", mt: 5 }} />
        </Box>
      </Box>

      {/* FOUR‑ITEM GRID aligned with hero section */}
      <Box sx={{ pb: 6 }}>
        <Box sx={{ maxWidth: 1240, width: "82%", mx: "auto", px: { xs: 2, md: 0 } }}>
          <Grid container spacing={2} justifyContent="flex-start">
            {(props.items || []).slice(0, 4).map((item, idx) => (
              <Grid item xs={6} sm={3} key={idx}>
                <Link to={item.link || "#"} style={{ textDecoration: "none" }}>
                  <ItemCard img={item.img} title={item.title} />
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
